import { render, staticRenderFns } from "./Score_Note.vue?vue&type=template&id=30c27d41&scoped=true"
import script from "./Score_Note.vue?vue&type=script&lang=js"
export * from "./Score_Note.vue?vue&type=script&lang=js"
import style0 from "./Score_Note.vue?vue&type=style&index=0&id=30c27d41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c27d41",
  null
  
)

export default component.exports